export default __webpack_public_path__ + "static/media/5.55bdd2db.svg";